import { Badge, Divider, Flex, Stack, Td, Text, Tr } from '@chakra-ui/react';
import TableCustom from '../../../../components/pages/CandidateArea/Table';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRequestMyImpugnation } from '../../../../services/hooks/CandidateArea/useRequestMyImpugnation';
import { TextXS } from '../../../../components/Text/Index';
import { badgeColor } from '../../../../utils/badgeFunction';
import { useContext } from 'react';
import { ContextAuth } from '../../../../contexts/Authentication';

const Impugnation: React.FC = () => {
  const headerImpugnation = ['PROTOCOLO', 'PROCESSO SELETIVO', 'SITUAÇÃO', 'AÇÕES'];
  const spId = useLocation().pathname.split('/')[3];
  const impugnationList = useRequestMyImpugnation();
  const navigate = useNavigate();
  const { isMobile } = useContext(ContextAuth);

  return (
    <Stack pb={'10px'} flexDir="column" justifyContent="space-between">
      {impugnationList.data && (
        <>
          {isMobile ? (
            <>
              {impugnationList.data
                .filter((i) => i.selective_process_id === spId)
                .map((impugnation) => (
                  <Stack
                    border="1px solid"
                    borderTopLeftRadius={4}
                    borderTopRightRadius={4}
                    w={'100%'}
                    bg="primaryColor"
                  >
                    <Text
                      color="white"
                      fontWeight="bold"
                      fontSize={13}
                      p={2}
                      px={4}
                      borderTopLeftRadius={3}
                      borderTopRightRadius={3}
                    >
                      {impugnation?.selective_process_name}
                    </Text>
                    <Stack bg="white" key={impugnation?.selective_process_id} p={5}>
                      <Flex gap={1} justify="center" flexDir={'column'}>
                        <Text fontWeight="bold">
                          Protocolo:{' '}
                          <Text fontWeight="normal" as={'span'}>
                            {impugnation?.protocol}
                          </Text>
                        </Text>
                      </Flex>

                      <Flex justify="center" flexDir={'column'} gap={1}>
                        <Text fontWeight="bold">
                          Situação:{' '}
                          <Badge
                            borderRadius={4}
                            textAlign="center"
                            lineHeight="normal"
                            p={1}
                            px={2}
                            bg={badgeColor(impugnation?.status)?.bgColor || 'black'}
                            color={badgeColor(impugnation?.status)?.color || 'white'}
                          >
                            {impugnation?.status}
                          </Badge>
                        </Text>
                      </Flex>

                      <Flex gap={1}>
                        <Text
                          onClick={() => {
                            navigate(`/painel/impugnacao/detalhes/${impugnation?.id}`);
                          }}
                          cursor="pointer"
                          color="colorLink"
                          textAlign="center"
                          fontWeight="bold"
                        >
                          Detalhes
                        </Text>
                      </Flex>
                      <Divider />
                    </Stack>
                  </Stack>
                ))}
            </>
          ) : (
            <TableCustom headers={headerImpugnation}>
              {impugnationList.data?.filter((i) => i.selective_process_id === spId).length === 0 && (
                <Td colSpan={4} textAlign="center">
                  <TextXS>Não possui impugnações protocoladas nesse edital</TextXS>
                </Td>
              )}

              {impugnationList.data &&
                impugnationList.data
                  ?.filter((i) => i.selective_process_id === spId)
                  .map((impugnation) => (
                    <Tr key={impugnation.id} textAlign="center">
                      <Td textAlign="center">
                        <TextXS> {impugnation?.protocol || 'Sem dados'}</TextXS>
                      </Td>
                      <Td textAlign="center">
                        <TextXS>{impugnation?.selective_process_name || 'Sem dados'}</TextXS>
                      </Td>
                      <Td textAlign="center">
                        <Badge
                          borderRadius={4}
                          textAlign="center"
                          lineHeight="normal"
                          p={1}
                          px={2}
                          bg={badgeColor(impugnation?.status)?.bgColor || 'black'}
                          color={badgeColor(impugnation?.status)?.color || 'white'}
                        >
                          {impugnation?.status}
                        </Badge>
                      </Td>
                      <Td
                        onClick={() => {
                          navigate(`/painel/impugnacao/detalhes/${impugnation?.id}`);
                        }}
                        cursor="pointer"
                        color="colorLink"
                        textAlign="center"
                      >
                        <TextXS>Detalhes</TextXS>
                      </Td>
                    </Tr>
                  ))}
            </TableCustom>
          )}
        </>
      )}
    </Stack>
  );
};

export default Impugnation;
